import state from './partsState'
import mutations from './partsMutations'
import actions from './partsActions'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
}
